export default __webpack_public_path__ + "static/media/venus_texture.59b4ebd0.jpg";